import { Injectable } from "@angular/core";
import { ClientService } from "../services/client.service";
import { Location } from "../types/Location/Location";
import { MapClientRepository } from "./abstract/map.client.repository";

@Injectable({
  providedIn: "root",
})
export class LocationRepository extends MapClientRepository<Location> {
  constructor(clientService: ClientService) {
    super(clientService, "locations");
  }
}
